/**
 * @desc 发送
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(body: defs.mns.MessageMasterSendDto, options?: any) {
  return updateResponse(
    http(URL + `/messageMaster/send`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
